import { jsxs as a, jsx as t } from "react/jsx-runtime";
import h from "react";
const f = h.memo(({
  size: o = "18px",
  fill: r = "none",
  ...e
}) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", height: o, viewBox: "0 0 18 18", width: o, fill: r, ...e, children: [
  /* @__PURE__ */ t("path", { d: "M0 2a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z", fill: "currentColor" }),
  /* @__PURE__ */ t("path", { d: "M5 8.964 8.075 12 14 6", stroke: "#fff", strokeWidth: "2", strokeLinecap: "round" })
] }));
export {
  f as default
};
//# sourceMappingURL=FormCheckbox.es.js.map
